import { createSlice } from '@reduxjs/toolkit';
import { hasCEORole } from './ceoAuth';

export const createCEOInitialState = () => ({
  isAuthenticated: false,
  queue: {},
  sessionToken: null,
  dashboard: { nav_trace: '' },
});

export const ceoReducer = createSlice({
  name: 'ceo_store',
  initialState: createCEOInitialState(),
  reducers: {
    startCEOAction: (state, action) => {
      if (!hasCEORole(action.payload) || !action.payload?.sessionToken) return createCEOInitialState();
      state.queue = {
        staffPayload: action.payload.staffPayload,
        authenticationType: action.payload.authenticationType,
      };
      state.sessionToken = action.payload.sessionToken || null;
      state.isAuthenticated = true;
    },
    dispatchCEODashboardNavigator: (state, action) => {
      state.dashboard.nav_trace = action.payload?.item || '';
    },
    logOutCEO: () => createCEOInitialState(),
  },
});

export const { startCEOAction, logOutCEO, dispatchCEODashboardNavigator } = ceoReducer.actions;
export default ceoReducer.reducer;
